import { render, staticRenderFns } from "./FolderCreate.vue?vue&type=template&id=a873e9b2&scoped=true&"
import script from "./FolderCreate.vue?vue&type=script&lang=js&"
export * from "./FolderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a873e9b2",
  null
  
)

export default component.exports